import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  UserProfileDto,
  UserRole,
  CreateQuestionDto,
  QuestionDto,
} from "@green0meter/api-client";

import { DOMAIN_DOUBLE_MATERIALITY } from "../domain";

import { roleGuard } from "@api";
import { doubleMaterialityQuestionsApi } from "@api/services";

const allowedRoles = [UserRole.Manager, UserRole.Owner];
const ACTION_GET_QUESTIONS = "GET_QUESTIONS";

const createQuestion = async (payload: CreateQuestionDto): Promise<QuestionDto> => {
  const response =
    await doubleMaterialityQuestionsApi.doubleMaterialityQuestionsControllerCreateQuestion(
      payload,
    );

  return response.data;
};

export const useCreateQuestion = (
  user: UserProfileDto | null,
): {
  createQuestion: (payload: CreateQuestionDto) => void;
  createQuestionAsync: (payload: CreateQuestionDto) => Promise<QuestionDto>;
  isPendingCreateQuestion: boolean;
  createQuestionEnabled: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: enabled ? createQuestion : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_DOUBLE_MATERIALITY, ACTION_GET_QUESTIONS],
      });
    },
  });

  return {
    createQuestion: (payload) => mutation.mutate(payload),
    createQuestionAsync: (payload) => mutation.mutateAsync(payload),
    isPendingCreateQuestion: mutation.isPending,
    createQuestionEnabled: enabled,
  };
};
